import React from "react";

let Context = React.createContext({
    state : {

    },
    dispatch: () => {}
})

export default Context;